import React from "react";
const Image = ({src})=>{
    return(<img src={src}/>)
}

export default Image;